import { Map } from 'immutable';

export default Map({
  loading: false,
  error: null,
  data: Map(),
});
